export const NOTIFICATION = 'notifications';
export const USER_SIGNOUT = 'user/signout';



// WEBPACK FOOTER //
// ./src/pages/profile/profilemenu/consts.ts